import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DbModalService} from "../../../../../../modules/modal/modal";
import {takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../user/user-subscription";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {ActivatedRoute, Router} from "@angular/router";
import {Observable} from "rxjs";
import {IBoosterStats} from "../../../../../../store/reducers/booster.reducer";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {WebsiteService} from "../../../../../website.service";

@Component({
    selector: 'db-image-limits-banner',
    templateUrl: './image-limits-banner.component.html',
    styleUrls: ['./image-limits-banner.component.scss'],
    standalone: false
})
export class ImageLimitsBannerComponent implements OnInit, OnDestroy {

  @Input() currentSubscription: UserSubscription;
  @Input() websiteId: number;

  public optimizerDisabled: boolean;
  public boosterSettings: any;
  public error: boolean;

  public websiteHosted: boolean;
  public loading: boolean = true;
  public stats: IBoosterStats;
  public pageLayout: boolean = false;
  public optimizeImagesStats$: Observable<any>;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _dbModal: DbModalService,
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    this._initData();
    this._getWebsiteBoosterStats();
    if (this.stats && !(this.stats.planLimit > this.stats.usedCountFromLimit)) {
      this.sendEvent('Dashboard Error', 'Images limit exceeded', 'IO')
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public sendEvent(category: string, action: string, label: string): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private _initData(): void {
    this.pageLayout = this._route.snapshot.data['pageId'] === 'image-optimizer';
  }



  private _getWebsiteBoosterStats(): void {
    this.optimizeImagesStats$ = this._store.select(fromStore.getImageOptimizerStats(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      );

    this.optimizeImagesStats$
      .subscribe(stats => {
        if (!TypeUtils.isNull(stats)) {
          this.stats = stats;
          this.error = false;
          this.loading = this.stats.compressIsRunning || false;
        } else {
          this.loading = false;
          this.error = true;
        }
      });
  }

}
